export default __webpack_public_path__ + "static/media/intuit-squarelogo-1573086631128.ec6acc3c.png";